/**
 * Location Card Component
 * Display location summary with actions
 */

import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

export default function LocationCard({ location, onEdit, onEditHours, onDelete }) {
  return (
    <div className="bg-white rounded-lg shadow hover:shadow-md transition-shadow p-6">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-xl font-bold text-gray-900">{location.name}</h3>
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(location)}
            className="text-gray-400 hover:text-primary-600 transition-colors"
            title="Edit location"
          >
            <PencilIcon className="w-5 h-5" />
          </button>
          <button
            onClick={() => onDelete(location.id)}
            className="text-gray-400 hover:text-red-600 transition-colors"
            title="Delete location"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        {location.address && (
          <div className="flex items-start gap-2 text-sm text-gray-600">
            <MapPinIcon className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" />
            <div>
              <div>{location.address}</div>
              {location.city && (
                <div>
                  {location.city}
                  {location.state && `, ${location.state}`}
                  {location.postalCode && ` ${location.postalCode}`}
                </div>
              )}
            </div>
          </div>
        )}

        {location.phone && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <PhoneIcon className="w-5 h-5 text-gray-400 flex-shrink-0" />
            <span>{location.phone}</span>
          </div>
        )}

        {location.email && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <EnvelopeIcon className="w-5 h-5 text-gray-400 flex-shrink-0" />
            <span>{location.email}</span>
          </div>
        )}

        {location.timezone && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <ClockIcon className="w-5 h-5 text-gray-400 flex-shrink-0" />
            <span>{location.timezone}</span>
          </div>
        )}
      </div>

      <div className="pt-4 border-t">
        <button
          onClick={() => onEditHours(location)}
          className="w-full px-4 py-2 text-sm font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors"
        >
          Manage Hours
        </button>
      </div>
    </div>
  );
}
